import { useEffect, useMemo, useState } from 'react';
import Container from '../../../../core/components/atoms/Container';
import BrainLoadingWrapper from '../../../../core/components/molecules/BrainLoading';
import { Typography } from '../../../../core/components/molecules/Typography';
import { Breadcrumbs } from '../../../../core/components/organism/Breadcrumbs';
import { MainCard } from '../../components/MainCard';
import RankItem from '../../components/RankItem';
import { useGetRankingComplete } from '../../hooks/useGetRankingComplete';
import { IRankingSimulation } from '../../models/feedbackRanking';
import { useSimuladaoStore } from '../../stores/simuladaoStore';
import { useParams } from 'react-router-dom';
import { useGetSimuladaoBySlug } from '../../hooks/useGetSimuladaoBySlug';

export default function RankingPage({
  isLoggedIn = false,
}: {
  isLoggedIn?: boolean;
}) {
  const { daySlug } = useParams();

  const { mutate, isLoading, data: rankingData } = useGetRankingComplete();
  const { data: simuladao, isLoading: loadingSimuladao } =
    useGetSimuladaoBySlug(daySlug);

  const [groupedData, setGroupedData] = useState<any[]>([]);
  const [maxLength, setMaxLength] = useState<number>(5);

  useEffect(() => {
    if (!daySlug) return;

    mutate(daySlug);
  }, [daySlug]);

  useEffect(() => {
    const data: IRankingSimulation[] = rankingData?.ranking || [];

    if (data && data.length > 0) {
      const screen: number = window.innerWidth;
      const wrapper: any[] = [];
      const maxLength: number = screen <= 1024 && screen >= 425 ? 3 : 5;

      setMaxLength(maxLength);

      let inner: IRankingSimulation[] = [];

      for (let x = 0; x < data.length; x++) {
        inner.push(data[x]);

        if ((x + 1) % maxLength === 0 || x === data.length - 1) {
          wrapper.push(inner);
          inner = [];
        }
      }

      setGroupedData(wrapper);
    }
  }, [rankingData]);

  const buildData = () => {
    if (rankingData && rankingData.ranking.length <= maxLength) {
      return (
        <>
          {groupedData.map((it, i) => (
            <MainCard key={i} className='flex gap-xl xs:flex-col md:flex-row'>
              {it.map((innerIt: any, ix: number) => {
                return (
                  <RankItem
                    key={ix}
                    name={innerIt.userName || 'Jubialuno'}
                    score={innerIt.finalScore}
                    position={`${ix + 1}º lugar`}
                  />
                );
              })}
            </MainCard>
          ))}
        </>
      );
    }

    let position = 0;
    return groupedData.map((it: any[], i: number) => {
      return (
        <MainCard key={i} className='flex gap-xl xs:flex-col md:flex-row'>
          {it.map((innerIt: any, ix: number) => {
            position += 1;
            return (
              <RankItem
                key={ix}
                name={innerIt.userName || 'Jubialuno'}
                score={innerIt.finalScore}
                position={`${position}º lugar`}
              />
            );
          })}
        </MainCard>
      );
    });
  };

  const breadcrumbsItems = useMemo(() => {
    const items = [];
    
    if (isLoggedIn) {
      items.push({
        label: 'Meus Simulados',
        href: `/simuladao/area-logada`,
      });
    }
    
    items.push(
      {
        label: `${simuladao?.name || 'Gabarito'} `,
        href: isLoggedIn
          ? `/simuladao/area-logada/gabarito/${daySlug}`
          : `/simuladao/gabarito/${daySlug}`,
      },
      {
        label: 'Ranking',
        href: '#',
      }
    );
    return items;
  }, [daySlug, isLoggedIn, simuladao]);

  if (isLoading) {
    return <BrainLoadingWrapper />;
  }

  return (
    <Container type='hd' className='flex flex-col gap-xxxl'>
      <Breadcrumbs items={breadcrumbsItems} />
      <Typography size='h1' type='title'>
        Ranking
      </Typography>
      {buildData()}
    </Container>
  );
}
